<app-modal #modal>
  <div class="modal-header">
    <h2 class="modal-title" style="text-align: center">{{ title }}</h2>
  </div>
  <div class="modal-body" style="text-align: center; padding-top: 30px;">
    <p [innerHTML]="message"></p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="onNotConfirmed()" class="btn btn-secondary" data-dismiss="modal">{{ cancelBtnText }}</a>
      </div>

      <div class="col-6">
        <a (click)="onConfirmed()" class="btn btn-primary">{{ confirmBtnText }}</a>
      </div>
    </div>
  </div>
</app-modal>
